// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__wYbzS","left":"Virtual_left__El8W9","wrapper":"Virtual_wrapper__V8+Zj"};